import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLazyGetNextRefinementItemQuery } from '../store/apis/rubric-refinement.api'

const PROCESSING_CHECK_INTERVAL_IN_MS = 3 * 1000

const usePeriodicRefinementNextItem = () => {
    const interval = useRef(null)
    const isProcessingNextItem = useSelector(state => state.rubricRefinement.isProcessingNextItem)
    const refinementProcessId = useSelector(state => state.rubricRefinement.refinementProcess?.id)
    const [fetchNextRefinementItem] = useLazyGetNextRefinementItemQuery()

    useEffect(() => {
        if (!isProcessingNextItem || !refinementProcessId) {
            return undefined
        }

        const poll = () => {
            if (document.hidden) {
                return
            }

            fetchNextRefinementItem({ id: refinementProcessId })
        }

        poll()
        interval.current = setInterval(poll, PROCESSING_CHECK_INTERVAL_IN_MS)

        return () => clearInterval(interval.current)
    }, [isProcessingNextItem, refinementProcessId, fetchNextRefinementItem])
}

export default usePeriodicRefinementNextItem
